import React from 'react';
import './ContactForm.css';
import emailjs from '@emailjs/browser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const ContactForm = () => {
    const sendEmail = (e) => {
        e.preventDefault();
        emailjs.sendForm('service_i2if91x', 'template_djes26v', e.target, 
        'user_I2G7ru6jh5W32gmXDqjzQ')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
            e.target.reset();
    }
    return (
        <section id="contact" className="contact__form">
            <div className="container">
                <h2 className="text-center title mb-3">Contact Me</h2>
                <form onSubmit={sendEmail}>
                    <input className="form-control my-2" type="email" name="email" placeholder="From" required />
                    <input className="form-control my-2" type="email" value="thejakia1@gmail.com" />
                    <input className="form-control my-2" type="text" name="subject" placeholder="Subject" required />
                    <input className="form-control my-2" type="text" name="name" placeholder="name" required />
                    <textarea className="form-control my-2" name="message" cols="30" rows="10" placeholder="Message" required ></textarea>
                    <button type="submit" className="portfolio__btn mt-2">Send <FontAwesomeIcon icon={faPaperPlane} /></button>
                </form>
            </div>
        </section>
    );
};

export default ContactForm;